import { useUnguardedHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { useTrowser } from '@/modules/navigation/trowsers/trowser.context';
import { TrowserKey } from '@/modules/navigation/trowsers/trowser.types';

import { ReviewSuggestionsTrowser } from './ReviewSuggestionsTrowser';

/** Mounts the site-wide Review Suggestions trowser when a household is active. */
export function ReviewSuggestionsTrowserMount() {
  const { householdId } = useUnguardedHouseholdDetailsContext();
  const reviewSuggestionsTrowser = useTrowser(TrowserKey.ReviewSuggestions);

  if (!householdId || !reviewSuggestionsTrowser.isOpen) return null;

  return <ReviewSuggestionsTrowser onClose={reviewSuggestionsTrowser.close} />;
}
